import styled from "styled-components";
import Icon from "@/atoms/Icon";

export const Label = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  font-size: 0.875rem;
  line-height: 1.3;
  font-weight: bold;
  gap: 8px;
`;

export const Checkmark = styled(Icon)`
  width: 50%;
  position: relative;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.2s ease;
`;

export const Indicator = styled.div`
  flex-shrink: 0;
  position: relative;
  margin-right: 1rem;
  height: var(--radioSize);
  width: var(--radioSize);
  text-align: center;
  &:before,
  &:after {
    position: absolute;
    content: "";
    border-radius: 50%;
    transition: all 0.2s ease;
    transition-property: transform, border-color;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  &:before {
    border: var(--radioBorderWidth) solid var(--radioBorderColor);
    box-sizing: border-box;
    background: #fff;
  }

  &:after {
    transform: scale(0);
    background: var(--radioCheckedColor);
  }
`;

export const StyledRadio = styled.div`
  font-size: 14px;
  display: flex;
  align-items: center;
  --radioSize: 11px;
  --radioBorderColor: #cf9ecd;
  --radioCheckedColor: #cf9ecd;
  --radioBorderWidth: 1px;

  background-color: ${({ highlightBackground, selectedValue, theme, value }) =>
    highlightBackground && selectedValue === value ? "#EFF2FF" : "transparent"};
}

  input[type="radio"] {
    display: none;

    &:checked + ${Indicator} {
      &:before {
        border-color: var(--radioCheckedColor);
      }

      &:after {
        transform: scale(1);
      }

      ${Checkmark} {
        opacity: 1;
      }
    }
  }

  &.wrapped {
    background: #ffffff;
    border: 1px solid #d7cad6;
    box-sizing: border-box;
    border-radius: 4px;

    ${Label} {
      padding: 1rem;
    }
  }
`;
